import { PRODUCT_CATEGORY } from './category';
import { IProviderDetails } from './countries';
import { Ilocation } from './global';
import { IpillsByReference } from './orders';
import { IConfiguration } from './product.configuration.types';

export type TypeCatalogue = IProductDetail[];

export interface IavailableCountry {
  countryCode: string;
  countryName: string;
  flag: string;
  active?: boolean;
  inStock?: boolean;
}
export interface IProductDetail {
  productId: number;
  imageUrl: string;
  brand?: string;
  brandImage?: string;
  commercialName: string;
  productStatus: string;
  category: string;
  uid: string;
  line: string;
  profiles: string[];
  availableCountries: IavailableCountry[];
  techRefence?: { [key: string]: string };
}

export interface IProductInfo {
  productId?: number;
  name?: string;
  model?: string;
  ram?: string;
  storage?: string;
  units?: number;
  pills?: IpillsByReference | null;
  category?: PRODUCT_CATEGORY;
  sku?: string;
  serial?: string;
}

export interface ISecondaryImg {
  id: number;
  url: string;
}

export interface IcountryPricingData {
  currency?: string;
  id?: number;
  name: string;
  nameCode: string;
  flag: string;
  currencyCode?: string;
  providerPrice?: number | null;
  nudosPrice?: number | string | null;
  nudosPriceUsd?: number | string | null;
  nudosPriceWithTaxes?: number | string | null;
  nudosPriceUsdWithTaxes?: number | string | null;
  margin?: number | null;
  isActive: number;
  providerId?: null | number;
  productStatus?: string;
  inStock: number;
  exchangeRate: number;
  taxRate: number;
  availableProviders?: IProviderDetails[];
}

export interface IproductSpecifications {
  displayInches?: string | null;
  resolution?: string | null;
  pixels?: string | null;
  fps?: string | null;
  color?: string | null;
  hardDrive?: string | null;
  processor?: string | null;
  ram?: string | null;
  software?: string | null;
  accessories?: string | null;
  inBoxAccessories?: string | null;
  material?: string | null;
  weight?: string | null;
  width?: string | null;
  length?: string | null;
  height?: string | null;
}

export interface IproductBasicData extends IproductSpecifications {
  productId?: number;
  commercialName: string;
  checkDaaS: boolean;
  brandId: number;
  lineId: number;
  description: string;
  uid: string;
  warranty: string;
  imageId: number;
  url?: string | null;
  dataSheet: string;
  dataSheetName: string;
  categoryId: string | number;
  pricingData: IcountryPricingData[];
  profiles: { id: number; name: string }[];
  providerId: number;
  positionId: number | null;
  position: string | null;
  isKit?: boolean;
  isActive?: boolean;
  canBeLoaded?: boolean;
  forceCreationOfRepeatedSku?: boolean;
}

export interface IProductDetailId extends IproductBasicData {
  profileIds?: number[] | null;
  secondaryImages: ISecondaryImg[];
}

export interface IProductDetailForm extends IproductBasicData {
  techReferenceId: number | null;
  furnitureId: number | null;
  brand: string;
  line: string;
  secondaryImages: ISecondaryImg[];
  category: string;
}

interface IImgInfo {
  catalogImageId: number;
  medium: string;
  name?: string;
}

export interface IDataImg {
  data: IImgInfo;
}

export interface IDataNewProduct {
  data: IProductDetailId;
}

export interface IDetailProviders {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  rut?: string;
}

export type IProviders = IDetailProviders[];

export interface ISheet {
  id: number | null;
  name: string | null;
  url: string | null;
  updatedAt: string | null;
  createdAt: string | null;
}

export interface ICreateProductResponse {
  status?: 'success' | 'error';
  message?: string;
  statusCode?: number;
  productId?: number;
}

export interface ISkuDuplicate {
  message: 'Product duplicate';
  data: { SKU: string; productId: number };
}

export interface IConditionOrStatusOption {
  id: number;
  name?: string;
  description?: string;
  backdescription?: string;
  label?: string;
  value?: string;
}

export interface ICondition {
  id: number;
  name: string;
  comments: string;
}
export interface IStatus {
  id: number;
  name: string;
  comments: string;
  fileUrl: string;
}
export interface IOrganization {
  organizationId: number;
  organizationName: string;
  organizationImage: string;
}

export interface IInTransitLocation {
  origin?: Ilocation;
  destination?: Ilocation;
  inTransit?: boolean;
}
export interface IToolData {
  id?: number;
  productId?: string;
  serial?: string;
  name?: string;
  brand?: string;
  brandImage?: string;
  image?: string;
  pills?: IpillsByReference | string;
  sku?: string;
  category?: string;
  productCondition?: string;
  location?: Ilocation;
  inTransit?: IInTransitLocation | null;
  referenceModel?: string;
  organizationName?: string;
  organization?: IOrganization;
  condition?: ICondition;
  status?: IStatus;
  employeeName?: string;
  configurations?: IConfiguration[];
  availableConditions?: IConditionOrStatusOption[];
  availableStatuses?: IConditionOrStatusOption[];
  stockOrderStatus?: string;
  comments?: string | null;
  isManageable?: boolean;
  isUploaded?: boolean;
}

export interface IProductsToChange {
  originalProductId: number;
  newProductId: number;
}

export interface IUpdateToolConditionDTO {
  productId: number;
  toolConditionId: number;
  comments: string;
}
export interface IToolToChange {
  organizationId: number;
  logisticServiceId: number;
  productsToReplace: IProductsToChange[];
}

export enum PRODUCT_CONDITION {
  NEW = 'Nuevo',
  USED_LIKE_NEW = 'Usado como nuevo',
  USED_GOOD = 'Usado bueno',
  USED_FAIR = 'Usado regular',
  USED_POOR = 'Usado mal',
  USED_VERY_POOR = 'Usado muy mal'
}

export enum STOCK_ORDER_STATUS {
  TO_ARRIVE = 'Por llegar',
  STORED = 'Almacenado',
  RESERVED = 'Reservado',
  DISPATCHED = 'Salió'
}

export enum PRODUCT_BRANDS {
  APPLE = 'Apple'
}
